
import rauCu from '../images/menuItems/alacarte/rauCu.jpg';
import goi from '../images/menuItems/alacarte/goi.jpg';
import khaiVi from '../images/menuItems/alacarte/khaiVi.jpg';
import kho from '../images/menuItems/alacarte/kho.jpg';
import hau from '../images/menuItems/alacarte/hau.jpg';
import dacSan from '../images/menuItems/alacarte/dacSan.jpg';
import muc from '../images/menuItems/alacarte/muc.jpg';
import caMu from '../images/menuItems/alacarte/caMu.jpg';
import caBop from '../images/menuItems/alacarte/caBop.jpg';
import heo from '../images/menuItems/alacarte/heo.jpg';
import bo from '../images/menuItems/alacarte/bo.jpg';
import ga from '../images/menuItems/alacarte/ga.jpg';
import thuySanDong from '../images/menuItems/alacarte/thuySanDong.jpg';
import com from '../images/menuItems/alacarte/com.jpg';
import lau from '../images/menuItems/alacarte/lau.jpg';
import haiSanTaiHo from '../images/menuItems/alacarte/haiSanTaiHo.jpg';
import doi from '../images/menuItems/alacarte/doi.jpg';
import doUong from '../images/menuItems/alacarte/doUong.jpg';

export const thucDon = [
    {
      name: "Khai Vị",
      image: khaiVi
    },
    {
      name: "Món Gỏi",
      image: goi
    },
    {
      name: "Rau củ Quả",
      image: rauCu
    },
    {
      name: "Các Loại Khô",
      image: kho
    },
    {
      name: "Hàu-Sò Huyết-Ốc",
      image: hau
    },
    {
      name: "Đặc Sản",
      image: dacSan
    },
    {
      name: "Mực-Tôm-Cua",
      image: muc
    },
    {
      name: "Cá Mú, Cá lăng, Cá Chình",
      image: caMu
    },
    {
      name: "Cá Bóp, Cá Bông Lau, Cá Kèo",
      image: caBop
    },
    {
      name: "Heo - Dê",
      image: heo
    },
    {
      name: "Món Bò",
      image: bo
    },
    {
      name: "Gà - Vịt",
      image: ga
    },
    {
      name: "Thủy Sản Đồng",
      image: thuySanDong
    },
    {
      name: "Món Cơm - Mì",
      image: com
    },
    {
      name: "Món Lẩu",
      image: lau
    },
    {
      name: "Hải Sản Tại Hồ",
      image: haiSanTaiHo
    },
    {
      name: "Món Dồi",
      image: doi
    },
    {
      name: "Đồ Uống",
      image: doUong
    }
  ];
  